module.exports = __webpack_public_path__ + "img/emoji_49.131a0ff7.png";